export default class NotificationBaseService {}
